// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a6158d59","239":"006312e5","344":"b49a5758","553":"248be29e"}[chunkId] + ".chunk.js";
};